import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WithdrawalInstruction } from '../../../../../../models/submissions/withdrawal-instruction';

@Component({
  selector: 'app-withdrawal-instructions-card',
  templateUrl: './withdrawal-instructions-card.component.html',
  styleUrls: ['./withdrawal-instructions-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WithdrawalInstructionsCardComponent {
  @Input({ required: true }) instruction!: WithdrawalInstruction;
}
